var _style, _path, _defs, _path2, _g, _defs2, _feBlend, _path3, _feBlend2, _g2, _defs3, _defs4, _mask, _defs5, _mask2, _feBlend3, _path4, _feBlend4, _g3, _path5, _path6, _g4, _path7, _polygon, _feBlend5, _g5, _defs6, _feBlend6, _path8, _polygon2, _polygon3, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 70",
    style: {
      enableBackground: "new 0 0 100 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA2330;}\r\n\t.st1{opacity:0.7;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{clip-path:url(#SVGID_7_);}\r\n\t.st8{fill:#072F54;}\r\n\t.st9{fill:#FBC108;}\r\n\t.st10{fill:#525A68;}\r\n\t.st11{fill:#5C0D34;}\r\n\t.st12{fill:#757F8B;}\r\n\t.st13{fill:#F48F00;}\r\n\t.st14{fill:#007FAD;}\r\n\t.st15{fill:#C94A30;}\r\n\t.st16{fill:#CDD0D2;}\r\n\t.st17{fill:none;}\r\n\t.st18{fill:#231F20;}\r\n\t.st19{fill:#DB3939;}\r\n\t.st20{fill:#FF5A5F;}\r\n\t.st21{fill:#1C191B;}\r\n\t.st22{clip-path:url(#SVGID_8_);}\r\n\t.st23{fill:#022C41;}\r\n\t.st24{fill:#720812;}\r\n\t.st25{fill:#750812;}\r\n\t.st26{fill:#770712;}\r\n\t.st27{fill:#7A0712;}\r\n\t.st28{fill:#7D0711;}\r\n\t.st29{fill:#800711;}\r\n\t.st30{fill:#820611;}\r\n\t.st31{fill:#850611;}\r\n\t.st32{fill:#880611;}\r\n\t.st33{fill:#8A0611;}\r\n\t.st34{fill:#8D0510;}\r\n\t.st35{fill:#900510;}\r\n\t.st36{fill:#930510;}\r\n\t.st37{fill:#950510;}\r\n\t.st38{fill:#980410;}\r\n\t.st39{fill:#9B0410;}\r\n\t.st40{fill:#9D040F;}\r\n\t.st41{fill:#A0040F;}\r\n\t.st42{fill:#A3030F;}\r\n\t.st43{fill:#A5030F;}\r\n\t.st44{fill:#A8030F;}\r\n\t.st45{fill:#AB030F;}\r\n\t.st46{fill:#AE020E;}\r\n\t.st47{fill:#B0020E;}\r\n\t.st48{fill:#B3020E;}\r\n\t.st49{fill:#B6020E;}\r\n\t.st50{fill:#B8010E;}\r\n\t.st51{fill:#BB010E;}\r\n\t.st52{fill:#BE010D;}\r\n\t.st53{fill:#C1010D;}\r\n\t.st54{fill:#C3000D;}\r\n\t.st55{fill:#C6000D;}\r\n\t.st56{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st57{filter:url(#Adobe_OpacityMaskFilter_1_);}\r\n\t.st58{mask:url(#SVGID_9_);}\r\n\t.st59{fill:#FFFFFF;}\r\n\t.st60{filter:url(#Adobe_OpacityMaskFilter_2_);}\r\n\t.st61{mask:url(#SVGID_10_);}\r\n\t.st62{fill:#DD9B82;}\r\n\t.st63{filter:url(#Adobe_OpacityMaskFilter_3_);}\r\n\t.st64{filter:url(#Adobe_OpacityMaskFilter_4_);}\r\n\t.st65{mask:url(#SVGID_11_);fill:#FFFFFF;}\r\n\t.st66{filter:url(#Adobe_OpacityMaskFilter_5_);}\r\n\t.st67{mask:url(#SVGID_13_);fill:#F1AB8D;}\r\n\t.st68{filter:url(#Adobe_OpacityMaskFilter_6_);}\r\n\t.st69{mask:url(#SVGID_14_);}\r\n\t.st70{filter:url(#Adobe_OpacityMaskFilter_7_);}\r\n\t.st71{mask:url(#SVGID_15_);}\r\n\t.st72{filter:url(#Adobe_OpacityMaskFilter_8_);}\r\n\t.st73{filter:url(#Adobe_OpacityMaskFilter_9_);}\r\n\t.st74{mask:url(#SVGID_16_);}\r\n\t.st75{opacity:0.75;fill:#E0A37D;}\r\n\t.st76{fill:#FDFBFF;}\r\n\t.st77{fill:#0055B2;}\r\n\t.st78{fill:#B8B4A5;}\r\n\t.st79{filter:url(#Adobe_OpacityMaskFilter_10_);}\r\n\t.st80{mask:url(#SVGID_17_);}\r\n\t.st81{fill:#1E160A;}\r\n\t.st82{filter:url(#Adobe_OpacityMaskFilter_11_);}\r\n\t.st83{filter:url(#Adobe_OpacityMaskFilter_12_);}\r\n\t.st84{mask:url(#SVGID_18_);}\r\n\t.st85{fill:#EB9A7D;}\r\n\t.st86{fill:#F59B88;}\r\n\t.st87{fill:#DD582F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M35.69,34.38l-0.29-0.11c-0.29-2.2-1.37-4.22-3.88-4.22c-2.99,0-3.9,3.43-3.9,5.7c0,2.28,0.91,5.7,3.9,5.7 c2.52,0,3.92-1.55,4.29-4l0.27-0.09l0.89,3.2c-1.88,0.96-3.53,1.48-5.97,1.48c-3.58,0-7.02-2.17-7.02-6.3s3.44-6.29,7.02-6.29 c2.3,0,4.32,0.44,5.83,1.22L35.69,34.38 M43.99,37.97v-1.65h-0.35c-1.85,0-3.42,0.87-3.42,2.96c0,1,0.6,2.03,1.68,2.03 C43.57,41.32,43.99,39.22,43.99,37.97 M44.11,40.15c-0.71,1.11-1.58,1.82-2.95,1.82c-1.89,0-3.91-0.71-3.91-2.86 c0-2.62,3.62-3.36,6.27-3.36h0.41v-0.83c0-1.49-0.82-2.52-2.17-2.52c-1.56,0.02-2.55,1.27-3.04,3.15l-0.28,0.08l-0.78-2.91 c1.62-0.48,3.17-0.96,4.82-0.91c2.51,0,4.18,1.02,4.18,4.19v3.71c0,0.84,0.22,1.54,1,1.75v0.27h-3.14L44.11,40.15z M54.22,35.03 l1.11-3.23H54.5c-1.53,0-2.51,1.65-2.9,2.97h-0.04v-1.14c0-0.55,0.04-1.09,0.04-1.57c-1.34,0.27-2.54,0.44-3.77,0.53v0.26 c0.56,0.11,1.15,0.5,1.15,1.8v3.95c0,1.54-0.26,2.61-1.26,2.89v0.26c0.87,0,1.76-0.07,2.62-0.07c0.85,0,1.75,0.07,2.61,0.07v-0.26 c-1-0.28-1.26-1.36-1.26-2.89v-1.43c0-1.36,0.37-2.81,1.45-2.81C53.63,34.38,53.92,34.69,54.22,35.03 M59.29,33.86v-1.8 c-1.29,0.27-2.49,0.44-3.72,0.53v0.26c0.56,0.11,1.15,0.5,1.15,1.8v3.95c0,1.54-0.26,2.61-1.26,2.89v0.26 c0.87,0,1.76-0.07,2.62-0.07c0.86,0,1.75,0.07,2.61,0.07v-0.26c-1-0.28-1.26-1.36-1.26-2.89v-2.21c0-1.18,0.43-3.58,2.02-3.58 c1.48,0,1.8,1.58,1.8,2.78v4.38c0,0.93-0.48,1.44-1.13,1.52v0.26c0.85,0,1.72-0.07,2.48-0.07c0.78,0,1.73,0.07,2.58,0.07v-0.26 c-0.85-0.17-1.22-0.65-1.22-1.52v-4.92c0-1.97-1.39-3.28-3.36-3.28c-1.59,0-2.61,0.7-3.28,2.11h-0.04V33.86 M71.15,39.43V32 c-1.28,0.28-2.49,0.44-3.72,0.53v0.26c0.56,0.12,1,0.51,1,1.08v5.56c0,1.11-0.26,1.87-1.26,2.02v0.26c0.87,0,1.76-0.07,2.62-0.07 c0.85,0,1.74,0.07,2.61,0.07v-0.26C71.41,41.3,71.15,40.54,71.15,39.43 M69.75,28.2c-0.82,0-1.41,0.72-1.41,1.51 c0,0.78,0.59,1.5,1.41,1.5c0.81,0,1.41-0.72,1.41-1.5C71.16,28.92,70.56,28.2,69.75,28.2z M77.36,41.41l2.91-5.88 c0.69-1.37,1.03-2,2.32-2.89v-0.26c-0.62,0-1.32,0.07-1.88,0.07c-0.56,0-1.2-0.07-1.82-0.07v0.26c0.71,0.17,1.15,0.5,1.15,1.08 c0,0.71-0.26,1.61-0.6,2.21l-1.35,2.46l-2.33-4.23c-0.1-0.17-0.19-0.44-0.19-0.66c0-0.52,0.63-0.77,1.09-0.86v-0.26 c-0.87,0-1.89,0.07-2.69,0.07c-0.8,0-1.71-0.07-2.6-0.07v0.33c0.94,0.58,0.74,0.28,1.74,2.04l3.43,6.66 c0.22,0.42,0.31,0.57,0.39,0.57h0.04C77.09,41.98,77.27,41.63,77.36,41.41 M89.25,37.97v-1.65h-0.34c-1.85,0-3.42,0.87-3.42,2.96 c0,1,0.59,2.03,1.69,2.03C88.83,41.32,89.25,39.22,89.25,37.97 M89.38,40.15c-0.71,1.11-1.58,1.82-2.95,1.82 c-1.9,0-3.91-0.71-3.91-2.86c0-2.62,3.61-3.36,6.26-3.36h0.41v-0.83c0-1.49-0.81-2.52-2.17-2.52c-1.56,0.02-2.56,1.27-3.04,3.15 l-0.28,0.08l-0.78-2.91c1.61-0.48,3.17-0.96,4.82-0.91c2.5,0,4.18,1.02,4.18,4.19v3.71c0,0.84,0.22,1.54,1,1.75v0.27h-3.14 L89.38,40.15z M94.16,30.5v8.06c0,1.54-0.26,2.62-1.26,2.9v0.26c0.87,0,1.76-0.07,2.61-0.07c0.86,0,1.75,0.07,2.62,0.07v-0.26 c-1-0.28-1.26-1.36-1.26-2.9v-8.37c0-0.69,0.05-1.42,0.05-1.99c-1.32,0.29-2.58,0.51-3.84,0.65v0.28 C93.88,29.29,94.16,29.67,94.16,30.5 M99.83,29.33c0-0.49-0.4-0.88-0.88-0.88c-0.49,0-0.88,0.39-0.88,0.88 c0,0.48,0.4,0.88,0.88,0.88C99.43,30.21,99.83,29.81,99.83,29.33 M98.48,29.91v-1.14h0.5c0.29,0,0.38,0.17,0.38,0.3 c0,0.18-0.13,0.32-0.32,0.33v0.01c0.1,0.03,0.17,0.13,0.26,0.28l0.14,0.22h-0.22l-0.09-0.18c-0.15-0.26-0.2-0.31-0.34-0.31h-0.11 v0.48H98.48 M98.66,29.27h0.26c0.14,0,0.24-0.06,0.24-0.17c0-0.1-0.09-0.17-0.21-0.17h-0.29V29.27 M98.94,30.38 c-0.58,0-1.06-0.47-1.06-1.06c0-0.59,0.47-1.06,1.06-1.06c0.58,0,1.06,0.47,1.06,1.06C100,29.91,99.53,30.38,98.94,30.38z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M21.43,26.98l10.43-5.93c0.01,0,0.01,0,0.01,0s0,0-0.01,0l0.01,0l-0.04-0.01 c-0.32-0.2-2.65-1.61-4.64-2.33c-1.41-0.51-2.99-0.92-3.1-0.67c0,0,0,0.01,0,0.01l-8.06,6.66l-4.33-0.44c0,0-0.77-0.12-0.87,1.6 c-0.1,1.8,1.5,1.37,1.5,1.37l0.29,0.8L0,41.83l20.22,0.04l0.61-12.91l0.01-0.02c0.46-0.17,1.6-0.6,1.62-0.66 c0.03-0.08,0.03-0.24,0.03-0.24l-1.1-0.88L21.43,26.98z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_1_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M21.02,26.88l1.46,1.16c0,0,0,0.16-0.03,0.24c-0.03,0.08-1.81,0.73-1.81,0.73L21.02,26.88z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M31.88,21.05l-10.44,5.93l-0.61,1.98l-0.61,12.91L0,41.83l12.62-13.79l-0.29-0.8c0,0-1.6,0.42-1.5-1.37 c0.1-1.72,0.87-1.6,0.87-1.6l4.33,0.44l8.09-6.68L31.88,21.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M31.36,21.27c-0.02,0.04-10.15,5.77-10.13,5.86c0.01,0.07-0.54,2.16-0.53,2.2 c0.01,0.03-0.58,12.54-0.58,12.54L0.23,41.83c0,0,12.39-13.69,12.44-13.79c0.02-0.04-0.28-0.84-0.28-0.84s-1.61,0.42-1.52-1.34 c0.09-1.67,0.87-1.56,0.87-1.56l4.3,0.44l7.95-6.45C23.98,18.3,31.38,21.23,31.36,21.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M30.84,21.49c-0.04,0.08-9.85,5.61-9.82,5.78c0.03,0.15-0.47,2.34-0.45,2.43 c0.01,0.05-0.55,12.16-0.55,12.16L0.46,41.83c0,0,12.16-13.59,12.25-13.79c0.04-0.09-0.28-0.87-0.28-0.87s-1.63,0.41-1.53-1.31 c0.09-1.63,0.86-1.51,0.86-1.51l4.26,0.43l7.81-6.22C23.84,18.57,30.88,21.41,30.84,21.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30.33,21.72c-0.05,0.12-9.55,5.45-9.5,5.71c0.04,0.22-0.41,2.52-0.37,2.65 c0.02,0.08-0.52,11.79-0.52,11.79L0.69,41.83c0,0,11.93-13.49,12.07-13.79c0.06-0.13-0.27-0.9-0.27-0.9s-1.64,0.4-1.55-1.27 c0.09-1.59,0.86-1.46,0.86-1.46l4.22,0.43l7.68-5.98C23.71,18.85,30.39,21.58,30.33,21.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M29.81,21.94c-0.07,0.17-9.25,5.29-9.19,5.64c0.06,0.3-0.34,2.7-0.29,2.88c0.03,0.1-0.49,11.42-0.49,11.42 L0.92,41.83c0,0,11.7-13.39,11.89-13.79c0.08-0.17-0.26-0.94-0.26-0.94s-1.65,0.39-1.56-1.24c0.08-1.55,0.86-1.42,0.86-1.42 l4.19,0.42l7.54-5.75C23.57,19.12,29.89,21.76,29.81,21.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M29.29,22.16c-0.09,0.21-8.95,5.13-8.87,5.56c0.07,0.37-0.27,2.88-0.21,3.11 c0.04,0.13-0.46,11.04-0.46,11.04L1.15,41.83c0,0,11.47-13.29,11.7-13.79c0.1-0.22-0.25-0.97-0.25-0.97s-1.66,0.39-1.58-1.2 c0.08-1.5,0.85-1.37,0.85-1.37l4.15,0.42l7.41-5.52C23.44,19.39,29.39,21.94,29.29,22.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M28.78,22.38c-0.11,0.25-8.66,4.97-8.56,5.49c0.08,0.45-0.21,3.06-0.13,3.33 c0.04,0.16-0.43,10.67-0.43,10.67L1.39,41.83c0,0,11.24-13.19,11.52-13.8c0.12-0.26-0.25-1-0.25-1s-1.67,0.38-1.59-1.17 c0.08-1.46,0.85-1.33,0.85-1.33l4.11,0.42l7.27-5.29C23.3,19.66,28.89,22.12,28.78,22.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M28.26,22.6c-0.13,0.29-8.36,4.81-8.24,5.41c0.1,0.52-0.14,3.25-0.05,3.56c0.05,0.18-0.4,10.29-0.4,10.29 L1.62,41.83c0,0,11.01-13.09,11.34-13.8c0.14-0.3-0.24-1.04-0.24-1.04s-1.69,0.37-1.6-1.13c0.08-1.42,0.85-1.28,0.85-1.28 l4.08,0.41l7.13-5.06C23.17,19.94,28.39,22.3,28.26,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M27.74,22.83c-0.15,0.33-8.06,4.65-7.93,5.34c0.11,0.6-0.07,3.43,0.03,3.79c0.06,0.21-0.37,9.92-0.37,9.92 L1.85,41.83c0,0,10.78-12.99,11.15-13.8c0.16-0.35-0.23-1.07-0.23-1.07s-1.7,0.37-1.62-1.1c0.07-1.38,0.84-1.24,0.84-1.24 l4.04,0.41l7-4.82C23.03,20.21,27.9,22.47,27.74,22.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M27.22,23.05c-0.16,0.37-7.76,4.49-7.62,5.26c0.13,0.67-0.01,3.61,0.11,4.01 c0.07,0.24-0.34,9.54-0.34,9.54L2.08,41.83c0,0,10.56-12.89,10.97-13.8c0.18-0.39-0.22-1.11-0.22-1.11s-1.71,0.36-1.63-1.07 c0.07-1.33,0.84-1.19,0.84-1.19l4.01,0.4l6.86-4.59C22.9,20.48,27.4,22.65,27.22,23.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M26.71,23.27c-0.18,0.42-7.46,4.33-7.3,5.19c0.14,0.75,0.06,3.79,0.19,4.24c0.07,0.26-0.31,9.17-0.31,9.17 L2.31,41.83c0,0,10.33-12.79,10.78-13.8c0.2-0.43-0.22-1.14-0.22-1.14s-1.72,0.35-1.65-1.03c0.07-1.29,0.84-1.15,0.84-1.15 l3.97,0.4l6.72-4.36C22.76,20.75,26.9,22.83,26.71,23.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M26.19,23.49c-0.2,0.46-7.16,4.17-6.99,5.11c0.15,0.82,0.13,3.97,0.26,4.47c0.08,0.29-0.28,8.8-0.28,8.8 L2.54,41.83c0,0,10.1-12.69,10.6-13.8c0.22-0.47-0.21-1.17-0.21-1.17s-1.73,0.34-1.66-1c0.07-1.25,0.84-1.1,0.84-1.1l3.93,0.39 l6.59-4.13C22.63,21.02,26.4,23.01,26.19,23.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M25.67,23.72c-0.22,0.5-6.87,4.01-6.67,5.04c0.17,0.9,0.19,4.15,0.34,4.69c0.09,0.31-0.26,8.42-0.26,8.42 L2.77,41.83c0,0,9.87-12.59,10.42-13.8c0.23-0.52-0.2-1.21-0.2-1.21s-1.74,0.34-1.68-0.96c0.06-1.2,0.83-1.06,0.83-1.06 l3.9,0.39l6.45-3.89C22.49,21.3,25.91,23.19,25.67,23.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M25.16,23.94c-0.24,0.54-6.57,3.85-6.36,4.96c0.18,0.97,0.26,4.34,0.42,4.92c0.1,0.34-0.23,8.05-0.23,8.05 L3,41.84c0,0,9.64-12.49,10.23-13.81c0.25-0.56-0.19-1.24-0.19-1.24s-1.76,0.33-1.69-0.93c0.06-1.16,0.83-1.01,0.83-1.01 l3.86,0.38l6.32-3.66C22.36,21.57,25.41,23.36,25.16,23.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M24.64,24.16c-0.26,0.58-6.27,3.69-6.04,4.89c0.2,1.05,0.33,4.52,0.5,5.15c0.1,0.37-0.2,7.67-0.2,7.67 L3.23,41.84c0,0,9.41-12.39,10.05-13.81c0.27-0.6-0.18-1.27-0.18-1.27s-1.77,0.32-1.71-0.89c0.06-1.12,0.83-0.97,0.83-0.97 l3.82,0.38l6.18-3.43C22.22,21.84,24.91,23.54,24.64,24.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M24.12,24.38c-0.27,0.62-5.97,3.53-5.73,4.81c0.21,1.12,0.39,4.7,0.58,5.37c0.11,0.39-0.17,7.3-0.17,7.3 L3.46,41.84c0,0,9.18-12.29,9.87-13.81c0.29-0.65-0.18-1.31-0.18-1.31s-1.78,0.32-1.72-0.86c0.05-1.08,0.82-0.92,0.82-0.92 l3.79,0.38l6.04-3.2C22.09,22.11,24.41,23.72,24.12,24.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M23.6,24.6c-0.29,0.67-5.67,3.37-5.42,4.74c0.22,1.19,0.46,4.88,0.66,5.6c0.12,0.42-0.14,6.93-0.14,6.93 L3.7,41.84c0,0,8.95-12.19,9.68-13.81c0.31-0.69-0.17-1.34-0.17-1.34s-1.79,0.31-1.74-0.82c0.05-1.03,0.82-0.88,0.82-0.88 l3.75,0.37l5.91-2.97C21.95,22.39,23.92,23.9,23.6,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M23.09,24.83c-0.31,0.71-5.38,3.2-5.1,4.67c0.24,1.27,0.53,5.06,0.74,5.82c0.13,0.45-0.11,6.55-0.11,6.55 L3.93,41.84c0,0,8.72-12.09,9.5-13.81c0.33-0.73-0.16-1.38-0.16-1.38s-1.8,0.3-1.75-0.79c0.05-0.99,0.82-0.83,0.82-0.83 l3.72,0.37l5.77-2.73C21.82,22.66,23.42,24.08,23.09,24.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M22.57,25.05c-0.33,0.75-5.08,3.04-4.79,4.59c0.25,1.34,0.59,5.24,0.82,6.05 c0.13,0.47-0.08,6.18-0.08,6.18L4.16,41.84c0,0,8.49-11.99,9.32-13.81c0.35-0.78-0.15-1.41-0.15-1.41s-1.82,0.29-1.77-0.76 c0.05-0.95,0.81-0.79,0.81-0.79l3.68,0.36l5.64-2.5C21.68,22.93,22.92,24.25,22.57,25.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M22.05,25.27c-0.35,0.79-4.78,2.88-4.47,4.52c0.27,1.42,0.66,5.43,0.9,6.28c0.14,0.5-0.05,5.8-0.05,5.8 L4.39,41.84c0,0,8.26-11.89,9.13-13.81c0.37-0.82-0.15-1.44-0.15-1.44s-1.83,0.29-1.78-0.72c0.04-0.9,0.81-0.74,0.81-0.74 l3.64,0.36l5.5-2.27C21.55,23.2,22.42,24.43,22.05,25.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M21.54,25.49c-0.37,0.83-4.48,2.72-4.16,4.44c0.28,1.49,0.73,5.61,0.98,6.5c0.15,0.52-0.02,5.43-0.02,5.43 L4.62,41.84c0,0,8.03-11.79,8.95-13.82c0.39-0.86-0.14-1.48-0.14-1.48s-1.84,0.28-1.8-0.69c0.04-0.86,0.81-0.7,0.81-0.7 l3.61,0.35l5.36-2.04C21.41,23.48,21.92,24.61,21.54,25.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M21.02,25.71c-0.38,0.87-4.18,2.56-3.84,4.37c0.29,1.57,0.79,5.79,1.06,6.73 c0.16,0.55,0.01,5.05,0.01,5.05L4.85,41.84c0,0,7.8-11.69,8.77-13.82c0.41-0.91-0.13-1.51-0.13-1.51s-1.85,0.27-1.81-0.65 c0.04-0.82,0.8-0.65,0.8-0.65l3.57,0.35l5.23-1.81C21.28,23.75,21.43,24.79,21.02,25.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M20.5,25.94c-0.4,0.92-3.88,2.4-3.53,4.29c0.31,1.64,0.86,5.97,1.14,6.96c0.16,0.58,0.04,4.68,0.04,4.68 L5.08,41.84c0,0,7.57-11.6,8.58-13.82c0.43-0.95-0.12-1.54-0.12-1.54s-1.86,0.27-1.82-0.62c0.04-0.78,0.8-0.61,0.8-0.61 l3.53,0.34l5.09-1.57C21.14,24.02,20.93,24.97,20.5,25.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M19.99,26.16c-0.42,0.96-3.59,2.24-3.22,4.22c0.32,1.72,0.93,6.15,1.22,7.18c0.17,0.6,0.07,4.31,0.07,4.31 L5.31,41.84c0,0,7.34-11.5,8.4-13.82c0.45-0.99-0.12-1.58-0.12-1.58s-1.87,0.26-1.84-0.58c0.03-0.73,0.8-0.56,0.8-0.56l3.5,0.34 l4.95-1.34C21.01,24.29,20.43,25.14,19.99,26.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M19.47,26.38c-0.44,1-3.29,2.08-2.9,4.14c0.34,1.79,0.99,6.33,1.3,7.41c0.18,0.63,0.1,3.93,0.1,3.93 L5.54,41.84c0,0,7.11-11.4,8.21-13.82c0.47-1.04-0.11-1.61-0.11-1.61s-1.89,0.25-1.85-0.55c0.03-0.69,0.79-0.52,0.79-0.52 l3.46,0.34l4.82-1.11C20.87,24.57,19.93,25.32,19.47,26.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M18.95,26.6c-0.46,1.04-2.99,1.92-2.59,4.07c0.35,1.87,1.06,6.52,1.37,7.64c0.18,0.66,0.13,3.56,0.13,3.56 L5.77,41.84c0,0,6.89-11.3,8.03-13.82c0.49-1.08-0.1-1.65-0.1-1.65s-1.9,0.24-1.87-0.52c0.03-0.65,0.79-0.47,0.79-0.47 l3.43,0.33l4.68-0.88C20.74,24.84,19.44,25.5,18.95,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M18.43,26.82c-0.48,1.08-2.69,1.76-2.27,3.99c0.36,1.94,1.13,6.7,1.45,7.86c0.19,0.68,0.16,3.18,0.16,3.18 L6.01,41.84c0,0,6.66-11.2,7.85-13.82c0.51-1.12-0.09-1.68-0.09-1.68s-1.91,0.24-1.88-0.48c0.02-0.61,0.79-0.43,0.79-0.43 l3.39,0.33l4.55-0.65C20.6,25.11,18.94,25.68,18.43,26.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M17.92,27.05c-0.49,1.12-2.39,1.6-1.96,3.92c0.38,2.02,1.19,6.88,1.53,8.09c0.2,0.71,0.19,2.81,0.19,2.81 L6.24,41.84c0,0,6.43-11.1,7.66-13.82c0.53-1.17-0.08-1.71-0.08-1.71s-1.92,0.23-1.9-0.45c0.02-0.56,0.78-0.38,0.78-0.38 l3.35,0.32l4.41-0.41C20.47,25.38,18.44,25.86,17.92,27.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M17.4,27.27c-0.51,1.17-2.09,1.44-1.64,3.84c0.39,2.09,1.26,7.06,1.61,8.32c0.21,0.73,0.22,2.43,0.22,2.43 L6.47,41.84c0,0,6.2-11,7.48-13.83c0.55-1.21-0.08-1.75-0.08-1.75s-1.93,0.22-1.91-0.41c0.02-0.52,0.78-0.34,0.78-0.34 l3.32,0.32l4.27-0.18C20.33,25.66,17.94,26.03,17.4,27.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M16.88,27.49c-0.53,1.21-1.8,1.28-1.33,3.77c0.41,2.17,1.33,7.24,1.69,8.54c0.21,0.76,0.25,2.06,0.25,2.06 L6.7,41.84c0,0,5.97-10.9,7.3-13.83c0.57-1.25-0.07-1.78-0.07-1.78s-1.95,0.22-1.93-0.38c0.02-0.48,0.78-0.29,0.78-0.29 l3.28,0.31l4.14,0.05C20.2,25.93,17.45,26.21,16.88,27.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M16.37,27.71c-0.55,1.25-1.5,1.12-1.02,3.69c0.42,2.24,1.39,7.42,1.77,8.77c0.22,0.79,0.27,1.69,0.27,1.69 L6.93,41.84c0,0,5.74-10.8,7.11-13.83c0.59-1.29-0.06-1.81-0.06-1.81s-1.96,0.21-1.94-0.34c0.01-0.43,0.77-0.25,0.77-0.25 l3.25,0.31l4,0.28C20.06,26.2,16.95,26.39,16.37,27.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M19.92,26.47c0,0-3.48,0.1-4.08,1.46c-0.57,1.29-1.2,0.96-0.7,3.62c0.43,2.31,1.46,7.61,1.85,8.99 c0.23,0.81,0.3,1.31,0.3,1.31L7.16,41.84c0,0,5.51-10.7,6.93-13.83c0.61-1.34-0.05-1.85-0.05-1.85s-1.97,0.2-1.96-0.31 c0.01-0.39,0.77-0.2,0.77-0.2l3.21,0.3L19.92,26.47z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1.49,
    y: 27.37,
    width: 12.8,
    height: 14.48
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.49,
    y: 27.37,
    width: 12.8,
    height: 14.48,
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 0.2,
    y: 26.48,
    width: 15.33,
    height: 17.46
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.2,
    y: 26.48,
    width: 15.33,
    height: 17.46,
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 20,
    height: 22,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF9AAABkwAAAbj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAFAMBIgACEQEDEQH/ xABtAAEBAQEBAAAAAAAAAAAAAAAAAQIDBwEBAAAAAAAAAAAAAAAAAAAAABAAAQQDAQAAAAAAAAAA AAAAAQAgEQIQQQMSEQADAAMAAAAAAAAAAAAAAAAAECEBERISAQAAAAAAAAAAAAAAAAAAACD/2gAM AwEAAhEDEQAAAPP9XZxBYAH/2gAIAQIAAQUAZ//aAAgBAwABBQBn/9oACAEBAAEFAEKEjfOsnpcA KvpGcf/aAAgBAgIGPwAf/9oACAEDAgY/AB//2gAIAQEBBj8ANqnOFCr/2Q==",
    transform: "matrix(1 0 0 1 -2 24)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_2_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M10.86,37.74c-3.9,4.61-8.39,7.22-10.05,5.82c-1.65-1.4,0.16-6.27,4.06-10.88 c3.89-4.61,8.39-7.22,10.05-5.83C16.57,28.25,14.75,33.12,10.86,37.74z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 1.49,
    y: 27.37,
    width: 12.8,
    height: 14.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.49,
    y: 27.37,
    width: 12.8,
    height: 14.48,
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st60"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 18,
    height: 19,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGSAAABrgAAAiz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAEgMBIgACEQEDEQH/ xACAAAEBAQEAAAAAAAAAAAAAAAAABgIHAQEAAAAAAAAAAAAAAAAAAAAAEAABBAIDAAAAAAAAAAAA AAAGACAEBRACAzQVEQACAQICBwgDAAAAAAAAAAABAhEDBBIFABAhMkITMzFBUWEiUmI0FDUGEgEA AAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAADn9M0S4KiXAD//2gAIAQIAAQUAZ//aAAgBAwAB BQBn/9oACAEBAAEFAEP0EPyUFi2t7JNyDisZaquhj//aAAgBAgIGPwAf/9oACAEDAgY/AB//2gAI AQEBBj8A0uv6POVL2FsGWhbS9P8AIqbEWXQSFxsFBXimYCkHR7i7lcvtSBUAkGs528tW7gOKDO0R 2yEy2wKDLLD00jSJ5dR8IWQohcKbqwPEgw2rLf3nWqfU6G7X+p8/d5Y9f//Z",
    transform: "matrix(1 0 0 1 -1 25)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_4_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1.49,41.83l12.63-14.47l0.17,0.67L3.16,41.84L1.49,41.83z M5.74,41.84l7.68-11.96l-0.04-0.54 l-8.19,12.5L5.74,41.84z"
  }))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23,
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23,
    id: "SVGID_5_"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_5_)",
      fill: "#FFFFFF"
    },
    d: "M12.48,32.01c-1.53,2.76-1.91,5.48-0.85,6.07 c1.06,0.59,3.16-1.17,4.69-3.94c1.53-2.76,1.91-5.48,0.85-6.06C16.11,27.49,14.01,29.25,12.48,32.01z"
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23,
    id: "SVGID_6_"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_6_)",
      fill: "#F1AB8D"
    },
    d: "M12.48,32.01c-1.53,2.76-1.91,5.48-0.85,6.07 c1.06,0.59,3.16-1.17,4.69-3.94c1.53-2.76,1.91-5.48,0.85-6.06C16.11,27.49,14.01,29.25,12.48,32.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.03,
    y: 27.97,
    width: 6.74,
    height: 10.23,
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st68"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 11,
    height: 16,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF0AAABhAAAAar/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABAACwMBIgACEQEDEQH/ xABoAAEBAAAAAAAAAAAAAAAAAAACBgEBAAAAAAAAAAAAAAAAAAAAABAAAwEBAAAAAAAAAAAAAAAA AAECAxERAAIBBQAAAAAAAAAAAAAAAAABEBFBUYECEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIR AxEAAACCKB//2gAIAQIAAQUAP//aAAgBAwABBQA//9oACAEBAAEFAIzdnBaOYP/aAAgBAgIGPwB/ /9oACAEDAgY/AH//2gAIAQEBBj8AeEboPlXj/9k=",
    transform: "matrix(1 0 0 1 9 25)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_7_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M12.48,32.01c-1.53,2.76-1.91,5.48-0.85,6.07c1.06,0.59,3.16-1.17,4.69-3.94 c1.53-2.76,1.91-5.48,0.85-6.06C16.11,27.49,14.01,29.25,12.48,32.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41,
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st70"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 12,
    height: 17,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAFqAAABdQAAAZb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEADAMBIgACEQEDEQH/ xABeAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAABABAQAAAAAAAAAAAAAAAAAA ECARAQAAAAAAAAAAAAAAAAAAACASAQAAAAAAAAAAAAAAAAAAABD/2gAMAwEAAhEDEQAAAJ+AD//a AAgBAgABBQA//9oACAEDAAEFAD//2gAIAQEAAQUAr//aAAgBAgIGPwA//9oACAEDAgY/AD//2gAI AQEBBj8AX//Z",
    transform: "matrix(1 0 0 1 8 25)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_8_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41,
    id: "SVGID_8_"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M12.14,32.62c-1.71,3.09-2.24,6.08-1.18,6.67c1.06,0.59,3.31-1.44,5.03-4.54 c1.71-3.09,2.24-6.08,1.18-6.67C16.11,27.49,13.86,29.52,12.14,32.62z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    filterUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.41,
    y: 27.98,
    width: 7.3,
    height: 11.41,
    id: "SVGID_9_"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M12.14,32.62c-1.71,3.09-2.24,6.08-1.18,6.67c1.06,0.59,3.31-1.44,5.03-4.54 c1.71-3.09,2.24-6.08,1.18-6.67C16.11,27.49,13.86,29.52,12.14,32.62z"
  })))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M12.48,32.01c-1.53,2.76-1.91,5.48-0.85,6.07c1.06,0.59,3.16-1.17,4.69-3.94c1.53-2.76,1.91-5.48,0.85-6.06 C16.11,27.49,14.01,29.25,12.48,32.01z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M26.99,22.25c-2.28,0.57-9.68,2.52-11.55,6.02c-1.87,3.5,4.15,13.42,4.15,13.42l0.04,0.18l0.58,0 l0.61-12.91l0.61-1.98l10.42-5.92C31.56,21.14,29.13,21.72,26.99,22.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 38,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAsCAYAAADmZKH2AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAr5JREFUeNrsmI1uozAQhLExR5P0 2nv/92wLxuADaVcajQzYQE46KZZWJA5JPmb/bFfVa7zGvx3mSb+X+t1I193hLgYyOw89rQBfCrcG ZGmOIYy8jjlKugNQKSBLcJZgJriibSroDkJZspqullRaQEaxsOLmWArH7kMYNAdXdC2CLVADfBbI vUXKGTJVxYk1cG0A0MJDKdgC5WneJuIvC86QWjVB/SJTwBriDcFqcN1ID4DhEkvgFAyB2tnexFqx hlyKYAqrrrUEV1RK8IkUTCFus91ne8jrNwF2oI6CeYAathQqjTkDrlS1FqB3sDvAoSs1vkaCwVJy qM5xVircTYA+Zvuc7bfAtnJPBLUmcuMAFmR+omSIuaWEY60Vld4F7I9A3gVcy0IvAKjeMtfJ1cv8 CIBTiVu5dKByD1DuQ+Zq+QMFUPWW9z9gHcCHHLAc5Rxk5wPi7iFzhgLfC8z3bF9iCucFbM21RQlh oa4p4I2yNEKcMdg3KIdgUw5YBVmW6gioXgO1DjsCZii6EsF6SIgxFyy3t5qV5q6lIVDwqxu7RBJk lZAUXNxZveLriQqsJ+PSMeaqtaVcTACNtORBG6iWeXJhkRtz3cprsAHc5+V7ZkOlaaXQVmfhsM1g le8hrrSD+ESJYLjDw23EGK4sMNhbSBKMsZCo/PEM4J5yAWJJS0Qj99TyeZeAq86qtpUQEVyK7ehL vjMJ3EitaSxdeRxRLpJyPahmZd4B3A+4l2PtUrdyzKlyDu4fYKnkoROk+ubhUWfuugxtTnBZ1FFn 8AnIy5Vj9SytPmp6368sKKtnwgXavQeCm6iFXQK21/hjYkGIScI7rbCxLHoKnALhDh23eKlWl7XK vep8jjc9lpIkJg5p4hXZmnOQgwpGOs5KFe94RbyVnmymjg9ShTaeLb5njl1NptKv8Rr/3fgrwADZ ZrSGnkwKCAAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 6.7991 14.7991)"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M26.99,22.25c-2.28,0.57-9.68,2.52-11.55,6.02c-1.87,3.5,4.15,13.42,4.15,13.42l0.04,0.18l0.58,0 l0.61-12.91l0.61-1.98l10.42-5.92C31.56,21.14,29.13,21.72,26.99,22.25z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M21.43,26.98l9.91-5.63c-2.17,0.7-11.15,3.67-12.37,5.33c-1.16,1.59-1.13,3.22-0.93,4.27 c0.16,0.8,1.05,3.76,1.3,5.39c0.24,1.63,0.87,5.53,0.87,5.53l0.61-12.91L21.43,26.98z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "31.88,21.05 24.11,18.03 16.03,24.71 15.66,24.67 20.65,32.82 20.83,28.96 21.43,26.98  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_10_",
    filterUnits: "userSpaceOnUse",
    x: 11.22,
    y: 24.77,
    width: 0.75,
    height: 2.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 11.22,
    y: 24.77,
    width: 0.75,
    height: 2.05,
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st79"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 5,
    height: 7,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF2AAABgwAAAbP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAcABQMBIgACEQEDEQH/ xABrAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAABABAAMAAAAAAAAAAAAAAAAA ABMUBREAAgAFBQAAAAAAAAAAAAAAEhQAESExMkECIkITEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMB AAIRAxEAAACLB//aAAgBAgABBQB//9oACAEDAAEFAH//2gAIAQEAAQUAlza3/9oACAECAgY/AH// 2gAIAQMCBj8Af//aAAgBAQEGPwAfHewuBzoywZ5Yr8bX07R//9k=",
    transform: "matrix(1 0 0 1 9 22)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M11.96,25.81c-0.02,0.57-0.2,1.02-0.41,1.01c-0.21-0.01-0.35-0.47-0.33-1.04 c0.02-0.57,0.2-1.02,0.41-1.01C11.83,24.78,11.98,25.24,11.96,25.81z"
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_11_",
    filterUnits: "userSpaceOnUse",
    x: 16.37,
    y: 18.16,
    width: 8.03,
    height: 6.83
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 16.37,
    y: 18.16,
    width: 8.03,
    height: 6.83,
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st82"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_12_",
    filterUnits: "userSpaceOnUse",
    x: 15.04,
    y: 14.49,
    width: 11.23,
    height: 12.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 15.04,
    y: 14.49,
    width: 11.23,
    height: 12.38,
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 16,
    height: 17,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF8AAABlAAAAcD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAEAMBIgACEQEDEQH/ xABtAAABBQAAAAAAAAAAAAAAAAAAAQIDBAYBAQAAAAAAAAAAAAAAAAAAAAAQAQACAwAAAAAAAAAA AAAAAAQQAQACBREBAAICAwAAAAAAAAAAAAAAAQACEBEhMUESAQAAAAAAAAAAAAAAAAAAABD/2gAM AwEAAhEDEQAAAMWkrSiAf//aAAgBAgABBQCP/9oACAEDAAEFAI//2gAIAQEAAQUACC1Y0Wxb5rtD V0W0m4//2gAIAQICBj8AP//aAAgBAwIGPwA//9oACAEBAQY/AFXQQ9qxrfiBXoz/AP/Z",
    transform: "matrix(1 0 0 1 13 12)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_11_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M26.26,20.68c0,3.42-2.51,6.19-5.61,6.19c-3.1,0-5.61-2.77-5.61-6.19c0-3.42,2.51-6.19,5.61-6.19 C23.75,14.49,26.26,17.27,26.26,20.68z"
  })))))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "16.51,24.99 16.37,24.78 24.26,18.16 24.41,18.4  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "15.22,25.21 11.98,24.73 11.93,24.5 15.75,24.95  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M31.88,21.06c0,0-2.37-0.33-4.47-1.14c-1.75-0.68-3.44-1.63-3.32-1.88c0.12-0.25,1.7,0.16,3.1,0.67 C29.34,19.49,31.88,21.06,31.88,21.06z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner06);
export default __webpack_public_path__ + "static/media/partner-06.11393deefb0679f5f1890ad314214ec5.svg";
export { ForwardRef as ReactComponent };